import {
  useTranslation,
  Input,
  useInputTextValidationSchema,
} from '@testsigma/atoms';
import { useState } from 'react';
import * as yup from 'yup';

export const WdaStep1 = ({ value, setValue, setEnableSave }) => {
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const nameSchema = useInputTextValidationSchema('Profile Name');

  const schema = yup.object().shape({
    ProfileName: nameSchema,
  });

  const validateInput = async (value) => {
    try {
      await schema.validate({ ProfileName: value });
      setError('');
      setEnableSave(true);
    } catch (err) {
      setError(err.message);
      setEnableSave(false);
    }
  };

  return (
    <div className='flex pb-8'>
      <div
        className={`border-2-2 absolute border-opacity-20 border-gray-700 ${
          !error ? 'h-[75px]' : 'h-[100px]'
        } border ml-3 mt-6`}></div>
      <div className='flex h-6 w-6 items-center rounded-full bg-primary-1000'>
        <h1 className='mx-auto text-sm font-semibold text-white'>1</h1>
      </div>
      <div className='pl-6'>
        <p className='text-sm font-semibold text-unique-600'>
          {t('settings.ios_settings.step1.name')}
          <span className='text-red-600'>*</span>
        </p>
        <Input
          onChange={(value) => {
            setValue(value);
            validateInput(value);
          }}
          placeholder='Enter name'
          type='text'
          value={value}
          className='w-[360px] h-9 mt-3 bg-secondary-50 text-unique-600 text-sm font-normal px-2 rounded focus:outline-none focus:ring-2 focus:ring-primary-300'
        />
        {error && (
          <p className='text-sm text-red-600 font-normal pt-1.5'>{error}</p>
        )}
      </div>
    </div>
  );
};
